import React from 'react';
import { signOut } from 'firebase/auth';
import { getAuth } from "firebase/auth";
import '../styles/LoginLogoutContainer.css'
import GoogleIcon from '@mui/icons-material/Google';
import { useNavigate } from 'react-router-dom';


interface LogoutContainerProps {
    onLogout: () => void;
}

const LogoutContainer: React.FC<LogoutContainerProps> = ({ onLogout }) => {
    const handleLogout = async () => {
        const auth = getAuth();
        signOut(auth);
    };

    const navigate = useNavigate();

    return (
        <div className="logout-container">
            <button className="reviews-button" onClick={() => navigate('/reviews')}>
                Mis reseñas
            </button>
            <button className="logout-button" onClick={handleLogout}>
                Cerrar Sesion
                <GoogleIcon />
            </button>
        </div>
    );
};

export default LogoutContainer;
